<ds-item-page-cc-license-field
  [item]="item"
  [variant]="'small'"
  [ccLicenseUriField]="dcRightsUri"
  [ccLicenseNameField]="dcRights"
  [showLabel]="false"
  [showUrl]="false">
</ds-item-page-cc-license-field>
